import { cn } from '@/lib/utils';

const H4 = ({
    variant = 'default',
    color = 'black',
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default';
    color?: 'black' | 'inherit';
}) => {
    const variantClasses = {
        default:
            'lg:text-[20px] text-[18px] 2xl:text-[20px] pressura uppercase inline-block leading-[120%]',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <h4
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...props}
        />
    );
};

H4.displayName = 'H4';

export default H4;
